import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "flex-start",
    height: "100%",
    width: "100%",
    ...shorthands.padding("0px", "0px"),
  },
  categoryHeader: {
    fontWeight: "bold",
    marginBottom: "8px",
    marginLeft: "17px",
    display: "block",
  },
  menuItemsContainer: {
    display: "initial",
    paddingLeft: "12px",
    paddingRight: "12px",
    "@media (min-width: 0px) and (max-width: 499px)": {
      paddingLeft: "16px",
      paddingRight: "16px",
    },

    "@media (min-width: 500px) and (max-width: 1239px)": {
      display: "grid",
      gridTemplateColumns: "repeat(2, 1fr)",
      ...shorthands.gap("16px"),
    },
    "@media (min-width: 1240px)": {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      ...shorthands.gap("16px"),
    },
  },
  menuItemContainer: {
    display: "initial",
    "@media (min-width: 500px)": {
      minHeight: "110px",
    },
  },
});
